export enum Actions {
    // Damn love the symmetry in this
    Execute = 'execute',
    Delete = 'delete',
    Clear = 'clear',
    Undo = 'undo',
    Redo = 'redo',
    Theme = 'theme',
    Feedback = 'feedbck'
}
